module.exports = __webpack_public_path__ + "img/light_brown.01695195.svg";